import React,{useEffect,useMemo,useRef,useState}from'react';
import API from'../utils/api';
import{RED,BLACK,side,legalMoves}from'../games/xiangqiEngine';

const T={
  rr:'車',rn:'馬',rb:'相',ra:'仕',rk:'帥',rc:'炮',rp:'兵',
  br:'車',bn:'馬',bb:'象',ba:'士',bk:'將',bc:'砲',bp:'卒'
};

const errMsg=e=>
  e?.response?.data?.message||
  e?.message||
  '操作失败，请稍后重试';

const sideName=s=>s===RED?'红方':s===BLACK?'黑方':'';

const tableLabel=n=>
  String(n||'').padStart(2,'0')+'号房';

const playMoveSound=()=>{
  try{
    const AudioCtx=window.AudioContext||window.webkitAudioContext;
    if(!AudioCtx)return;

    if(!window.__xiangqiAudioCtx){
      window.__xiangqiAudioCtx=new AudioCtx();
    }

    const ctx=window.__xiangqiAudioCtx;

    if(ctx.state==='suspended'){
      ctx.resume().catch(()=>{});
    }

    const now=ctx.currentTime;
    const osc=ctx.createOscillator();
    const gain=ctx.createGain();

    osc.type='triangle';
    osc.frequency.setValueAtTime(190,now);
    osc.frequency.exponentialRampToValueAtTime(
      95,
      now+0.055
    );

    gain.gain.setValueAtTime(0.0001,now);
    gain.gain.exponentialRampToValueAtTime(
      0.28,
      now+0.003
    );
    gain.gain.exponentialRampToValueAtTime(
      0.0001,
      now+0.075
    );

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now+0.08);
  }catch(e){}
};


export default function ChineseChessOnline(){
  const[tables,setTables]=useState([]);
  const[room,setRoom]=useState(null);
  const[tableNo,setTableNo]=useState(null);
  const[spectating,setSpectating]=useState(false);
  const[sel,setSel]=useState(null);
  const[busy,setBusy]=useState(false);
  const[msg,setMsg]=useState('');
  const[profile,setProfile]=useState(null);

  const roomRef=useRef(null);
  const lastSoundMoveRef=useRef(null);
  roomRef.current=room;

  const board=room?.board||null;
  const mySide=spectating?null:room?.your_side||null;

  const loadProfile=async()=>{
    try{
      const r=await API.get('/games/xiangqi/online/profile');
      setProfile(r.data);
    }catch(e){}
  };

  const loadTables=async(silent=false)=>{
    try{
      const r=await API.get('/games/xiangqi/online/tables');
      const x=r.data?.tables||[];
      setTables(x);

      /*
       * 页面刷新后，如果本人已有固定房间棋局，
       * 通过 room_code 与大厅记录重新找到桌号。
       */
      if(roomRef.current?.room_code&&!tableNo){
        const hit=x.find(
          t=>t.room_code===roomRef.current.room_code
        );
        if(hit)setTableNo(Number(hit.table_no));
      }

      if(!silent)setMsg('');
      return x;
    }catch(e){
      if(!silent)setMsg(errMsg(e));
      return [];
    }
  };

  const loadCurrent=async()=>{
    try{
      const r=await API.get('/games/xiangqi/online/current');
      const x=r.data?.room||null;

      if(x){
        setRoom(x);
        setSpectating(false);

        const list=await loadTables(true);
        const hit=list.find(t=>t.room_code===x.room_code);

        if(hit)setTableNo(Number(hit.table_no));
      }
    }catch(e){}
  };

  const loadParticipantRoom=async(code,silent=true)=>{
    if(!code)return;

    try{
      const r=await API.get(
        '/games/xiangqi/online/'+code
      );

      const nextRoom=r.data?.room||null;

      if(
        nextRoom&&
        lastSoundMoveRef.current!==null&&
        Number(nextRoom.move_no)>Number(lastSoundMoveRef.current)
      ){
        playMoveSound();
      }

      if(nextRoom){
        lastSoundMoveRef.current=Number(nextRoom.move_no||0);
      }

      setRoom(nextRoom);
      if(!silent)setMsg('');
    }catch(e){
      if(!silent)setMsg(errMsg(e));
    }
  };

  const loadWatch=async(no,silent=true)=>{
    if(!no)return;

    try{
      const r=await API.get(
        '/games/xiangqi/online/tables/'+no+'/watch'
      );

      const nextRoom=r.data?.room||null;

      if(
        nextRoom&&
        lastSoundMoveRef.current!==null&&
        Number(nextRoom.move_no)>Number(lastSoundMoveRef.current)
      ){
        playMoveSound();
      }

      if(nextRoom){
        lastSoundMoveRef.current=Number(nextRoom.move_no||0);
      }

      setRoom(nextRoom);

      if(!silent)setMsg('');
    }catch(e){
      if(!silent)setMsg(errMsg(e));
    }
  };

  useEffect(()=>{
    loadProfile();
    loadTables(true);
    loadCurrent();

    const timer=setInterval(
      ()=>loadTables(true),
      1500
    );

    return()=>clearInterval(timer);
  },[]); // eslint-disable-line

  useEffect(()=>{
    if(!room?.room_code)return;
    if(!['waiting','playing'].includes(room.status))return;

    const timer=setInterval(()=>{
      const x=roomRef.current;
      if(!x)return;

      if(spectating){
        loadWatch(tableNo,true);
      }else{
        loadParticipantRoom(x.room_code,true);
      }
    },1000);

    return()=>clearInterval(timer);
  },[
    room?.room_code,
    room?.status,
    spectating,
    tableNo
  ]); // eslint-disable-line

  useEffect(()=>{
    setSel(null);

    if(
      lastSoundMoveRef.current===null&&
      room
    ){
      lastSoundMoveRef.current=Number(room.move_no||0);
    }

    if(room?.status==='finished'){
      loadProfile();
      loadTables(true);
    }
  },[room?.version_no,room?.status]); // eslint-disable-line

  const moves=useMemo(()=>{
    if(
      spectating||
      !board||
      !mySide||
      room?.status!=='playing'||
      room?.current_turn!==mySide
    )return[];

    try{
      return legalMoves(board,mySide);
    }catch(e){
      return[];
    }
  },[
    board,
    mySide,
    room?.status,
    room?.current_turn,
    spectating
  ]);

  const targets=useMemo(()=>{
    if(!sel)return[];

    return moves.filter(
      m=>m.from[0]===sel[0]&&m.from[1]===sel[1]
    );
  },[moves,sel]);

  const enterTable=async(no)=>{
    if(busy)return;

    setBusy(true);
    setMsg('');

    try{
      const r=await API.post(
        '/games/xiangqi/online/tables/'+no+'/enter'
      );

      setTableNo(Number(no));
      setSpectating(false);
      playMoveSound();

      if(r.data?.room){
        lastSoundMoveRef.current=Number(
          r.data.room.move_no||0
        );
      }

      setRoom(r.data.room);
      setSel(null);
      await loadTables(true);
    }catch(e){
      if(e?.response?.data?.code==='TABLE_PLAYING'){
        setMsg('该房间正在对战，可选择观战');
      }else{
        setMsg(errMsg(e));
      }
    }finally{
      setBusy(false);
    }
  };

  const watchTable=async(no)=>{
    if(busy)return;

    setBusy(true);
    setMsg('');

    try{
      const r=await API.get(
        '/games/xiangqi/online/tables/'+no+'/watch'
      );

      setTableNo(Number(no));
      setSpectating(true);
      setRoom(r.data.room);
      setSel(null);
    }catch(e){
      setMsg(errMsg(e));
      await loadTables(true);
    }finally{
      setBusy(false);
    }
  };

  const sendMove=async(m)=>{
    if(
      busy||
      spectating||
      !room||
      room.status!=='playing'||
      room.current_turn!==room.your_side
    )return;

    setBusy(true);
    setMsg('');

    try{
      const r=await API.post(
        '/games/xiangqi/online/'+room.room_code+'/move',
        {
          from:m.from,
          to:m.to,
          version_no:room.version_no
        }
      );

      setRoom(r.data.room);
      setSel(null);
    }catch(e){
      if(e?.response?.data?.code==='VERSION_CONFLICT'){
        await loadParticipantRoom(room.room_code,true);
        setMsg('棋局已同步，请重新走棋');
      }else{
        setMsg(errMsg(e));
      }
    }finally{
      setBusy(false);
    }
  };

  const clickCell=(r,c)=>{
    if(
      spectating||
      !board||
      busy||
      room?.status!=='playing'||
      room?.current_turn!==mySide
    )return;

    if(sel){
      const m=targets.find(
        x=>x.to[0]===r&&x.to[1]===c
      );

      if(m){
        sendMove(m);
        return;
      }
    }

    if(
      board[r][c]&&
      side(board[r][c])===mySide
    ){
      setSel([r,c]);
    }else{
      setSel(null);
    }
  };

  const cancelRoom=async()=>{
    if(!room||busy||spectating)return;
    if(!window.confirm('确定退出等待并释放这个房间吗？'))return;

    setBusy(true);

    try{
      await API.post(
        '/games/xiangqi/online/'+room.room_code+'/cancel'
      );

      setRoom(null);
      setTableNo(null);
      setSel(null);
      setMsg('');
      await loadTables(true);
    }catch(e){
      setMsg(errMsg(e));
    }finally{
      setBusy(false);
    }
  };

  const resign=async()=>{
    if(!room||busy||spectating)return;
    if(!window.confirm('确定认输吗？'))return;

    setBusy(true);

    try{
      const r=await API.post(
        '/games/xiangqi/online/'+room.room_code+'/resign'
      );

      setRoom(r.data.room);
      setSel(null);
      loadProfile();
      loadTables(true);
    }catch(e){
      setMsg(errMsg(e));
    }finally{
      setBusy(false);
    }
  };

  const draw=async action=>{
    if(!room||busy||spectating)return;

    setBusy(true);

    try{
      const r=await API.post(
        '/games/xiangqi/online/'+room.room_code+'/draw',
        {action}
      );

      setRoom(r.data.room);

      if(r.data.room?.status==='finished'){
        loadProfile();
        loadTables(true);
      }
    }catch(e){
      setMsg(errMsg(e));
    }finally{
      setBusy(false);
    }
  };

  const backLobby=async()=>{
    setRoom(null);
    setTableNo(null);
    setSpectating(false);
    setSel(null);
    setMsg('');
    await loadTables(true);
  };

  const statusText=()=>{
    if(!room)return'';

    if(spectating){
      if(room.status==='finished')return'本局已结束';
      return room.current_turn===RED
        ?'观战 · 红方走棋'
        :'观战 · 黑方走棋';
    }

    if(room.status==='waiting'){
      return'等待另一位业主加入';
    }

    if(room.status==='finished'){
      if(room.finish_reason==='draw')return'本局和棋';
      if(room.you_won)return'你赢了';
      return'本局结束';
    }

    if(room.current_turn===room.your_side){
      return'轮到你走棋';
    }

    return'等待对方走棋';
  };

  /*
   * =========================
   * 固定房间大厅
   * =========================
   */
  if(!room){
    return(
      <div style={S.wrap}>
        <div style={S.lobbyHead}>
          <div>
            <b style={S.lobbyTitle}>联机对战大厅</b>
            <div style={S.sub}>
              选择01～10号房，与小区用户实时对弈
            </div>
          </div>

          <button
            style={S.refresh}
            onClick={()=>loadTables(false)}
          >
            刷新
          </button>
        </div>

        {profile&&(
          <div style={S.stats}>
            <span>{profile.wins||0}胜</span>
            <span>{profile.losses||0}负</span>
            <span>{profile.draws||0}和</span>
            <span>{profile.total_games||0}局</span>
          </div>
        )}

        {msg&&<div style={S.msg}>{msg}</div>}

        <div style={S.rooms}>
          {tables.map(t=>{
            const no=Number(t.table_no);

            return(
              <div
                key={t.table_no}
                style={S.roomCard}
              >
                <div style={S.roomTop}>
                  <b style={S.roomNo}>
                    {tableLabel(t.table_no)}
                  </b>

                  <span style={{
                    ...S.badge,
                    ...(t.state==='empty'
                      ?S.emptyBadge
                      :t.state==='waiting'
                      ?S.waitBadge
                      :S.playBadge)
                  }}>
                    {t.state==='empty'
                      ?'无人'
                      :t.state==='waiting'
                      ?'等待中'
                      :'对战中'}
                  </span>
                </div>

                <div style={S.people}>
                  {t.state==='empty'&&
                    <span>当前无人，可进入等待对手</span>
                  }

                  {t.state==='waiting'&&
                    <span>
                      {t.red?.name||'业主'}
                      {t.red?.building
                        ?' · '+t.red.building
                        :''}
                      {' '}正在等待
                    </span>
                  }

                  {t.state==='playing'&&
                    <span>
                      {t.red?.name||'红方'}
                      {' VS '}
                      {t.black?.name||'黑方'}
                      {' · 第 '}
                      {t.move_no||0}
                      {' 手'}
                    </span>
                  }
                </div>

                {t.state==='empty'&&(
                  <button
                    style={S.enter}
                    disabled={busy}
                    onClick={()=>enterTable(no)}
                  >
                    进入
                  </button>
                )}

                {t.state==='waiting'&&(
                  <button
                    style={S.join}
                    disabled={busy}
                    onClick={()=>enterTable(no)}
                  >
                    加入对战
                  </button>
                )}

                {t.state==='playing'&&(
                  <button
                    style={S.watch}
                    disabled={busy}
                    onClick={()=>watchTable(no)}
                  >
                    观战
                  </button>
                )}
              </div>
            );
          })}
        </div>

        <div style={S.note}>
          房间状态自动刷新。联机对战仅用于休闲娱乐，不设下注、现金奖励或积分兑换。
        </div>
      </div>
    );
  }

  /*
   * =========================
   * 等待对手
   * =========================
   */
  if(room.status==='waiting'){
    return(
      <div style={S.wrap}>
        <button
          style={S.backLobby}
          onClick={backLobby}
        >
          ‹ 返回大厅
        </button>

        <div style={S.waitCard}>
          <div style={S.bigPiece}>帥</div>

          <div style={S.waitTitle}>
            {tableLabel(tableNo)}
          </div>

          <b style={S.waitingText}>
            等待对手加入
          </b>

          <div style={S.loading}>
            ●　●　●
          </div>

          <div style={S.waitTip}>
            其他业主进入联机大厅后，可以直接加入这个房间
          </div>

          <button
            style={S.cancel}
            disabled={busy}
            onClick={cancelRoom}
          >
            取消等待
          </button>
        </div>

        {msg&&<div style={S.msg}>{msg}</div>}
      </div>
    );
  }

  /*
   * =========================
   * 对局 / 观战
   * =========================
   */
  const reverse=!spectating&&mySide===BLACK;

  const redName=spectating
    ?room.red?.name||'红方'
    :mySide===RED
      ?'你'
      :room.opponent?.name||'对手';

  const blackName=spectating
    ?room.black?.name||'黑方'
    :mySide===BLACK
      ?'你'
      :room.opponent?.name||'对手';

  return(
    <div style={S.gameWrap}>
      <div style={S.gameTop}>
        <button
          style={S.backLobby}
          onClick={backLobby}
        >
          ‹ 返回大厅
        </button>

        <b>{tableLabel(tableNo)}</b>

        <span style={S.live}>
          ● 在线
        </span>
      </div>

      <div style={S.match}>
        <div>
          <b style={{color:'#b3261e'}}>
            {redName}
          </b>
          <span>红方 · 帥</span>
        </div>

        <strong>VS</strong>

        <div>
          <b>{blackName}</b>
          <span>黑方 · 將</span>
        </div>
      </div>

      <div style={{
        ...S.status,
        ...(spectating?S.spectatorStatus:{})
      }}>
        {statusText()}
        {' · 第 '}
        {room.move_no||0}
        {' 手'}
      </div>

      {!spectating&&
       room.opponent_draw_offer&&
       room.status==='playing'&&(
        <div style={S.drawOffer}>
          <b>对方请求和棋</b>
          <button onClick={()=>draw('accept')}>
            同意
          </button>
          <button onClick={()=>draw('decline')}>
            拒绝
          </button>
        </div>
      )}

      {!spectating&&
       room.your_draw_offer&&
       room.status==='playing'&&(
        <div style={S.drawWaiting}>
          已提出和棋，等待对方回应
        </div>
      )}

      {board&&(
        <div style={{
          ...S.board,
          transform:reverse?'rotate(180deg)':'none'
        }}>
          {board.map((row,r)=>
            row.map((p,c)=>{
              const can=targets.some(
                x=>x.to[0]===r&&x.to[1]===c
              );

              const chosen=
                sel&&sel[0]===r&&sel[1]===c;

              return(
                <button
                  key={r+'-'+c}
                  disabled={spectating}
                  onClick={()=>clickCell(r,c)}
                  style={{
                    ...S.cell,
                    left:(c*12.5)+'%',
                    top:(r*11.111)+'%',
                    transform:
                      'translate(-50%,-50%)'+
                      (reverse?' rotate(180deg)':'')
                  }}
                >
                  <span style={{
                    ...S.dot,
                    ...(can?S.can:{}),
                    ...(chosen?S.chosen:{})
                  }}>
                    {p&&(
                      <i style={{
                        ...S.piece,
                        color:side(p)===RED
                          ?'#b3261e'
                          :'#222'
                      }}>
                        {T[p]}
                      </i>
                    )}
                  </span>
                </button>
              );
            })
          )}

          <div style={S.river}>
            楚 河　　　漢 界
          </div>
        </div>
      )}

      {msg&&<div style={S.msg}>{msg}</div>}

      {!spectating&&room.status==='playing'&&(
        <div style={S.actions}>
          <button
            disabled={busy||room.your_draw_offer}
            onClick={()=>draw('offer')}
          >
            求和
          </button>

          <button
            disabled={busy}
            onClick={resign}
          >
            认输
          </button>
        </div>
      )}

      {spectating&&(
        <div style={S.watchTip}>
          当前为观战模式，只能观看，不能操作棋子。
        </div>
      )}

      {room.status==='finished'&&(
        <button
          style={S.returnBtn}
          onClick={backLobby}
        >
          返回联机大厅
        </button>
      )}
    </div>
  );
}

const S={
  wrap:{
    maxWidth:500,
    margin:'0 auto',
    padding:'4px 0 30px'
  },
  lobbyHead:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    margin:'6px 2px 10px'
  },
  lobbyTitle:{
    fontSize:18,
    color:'#4e342e'
  },
  sub:{
    fontSize:12,
    color:'#806d5e',
    marginTop:3
  },
  refresh:{
    border:'1px solid #b69b7a',
    borderRadius:8,
    background:'#fff8e9',
    padding:'7px 12px'
  },
  stats:{
    display:'flex',
    justifyContent:'space-around',
    background:'#fff8e9',
    border:'1px solid #dec9a6',
    borderRadius:10,
    padding:'9px 5px',
    marginBottom:10,
    fontSize:13,
    color:'#654'
  },
  rooms:{
    display:'grid',
    gridTemplateColumns:'repeat(2,minmax(0,1fr))',
    gap:9
  },
  roomCard:{
    background:'#fffaf0',
    border:'1px solid #dbc39b',
    borderRadius:12,
    padding:11,
    boxShadow:'0 2px 7px #5b3a1b12'
  },
  roomTop:{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center'
  },
  roomNo:{
    fontSize:17,
    color:'#563d2d'
  },
  badge:{
    fontSize:11,
    borderRadius:12,
    padding:'3px 7px'
  },
  emptyBadge:{
    background:'#ece8e0',
    color:'#766'
  },
  waitBadge:{
    background:'#fff0bd',
    color:'#8a6200'
  },
  playBadge:{
    background:'#dff3e6',
    color:'#207342'
  },
  people:{
    minHeight:38,
    fontSize:11,
    lineHeight:1.5,
    color:'#756456',
    padding:'7px 0 5px'
  },
  enter:{
    width:'100%',
    border:0,
    borderRadius:8,
    background:'#8c5a32',
    color:'#fff',
    padding:'8px 5px',
    fontWeight:700
  },
  join:{
    width:'100%',
    border:0,
    borderRadius:8,
    background:'#b3261e',
    color:'#fff',
    padding:'8px 5px',
    fontWeight:700
  },
  watch:{
    width:'100%',
    border:'1px solid #866f59',
    borderRadius:8,
    background:'#fff',
    color:'#5d4938',
    padding:'7px 5px',
    fontWeight:700
  },
  note:{
    marginTop:13,
    textAlign:'center',
    color:'#887463',
    fontSize:11,
    lineHeight:1.6
  },
  msg:{
    margin:'9px auto',
    padding:'8px 10px',
    background:'#fff1ef',
    color:'#a12620',
    borderRadius:8,
    fontSize:12,
    textAlign:'center'
  },
  backLobby:{
    border:0,
    background:'transparent',
    color:'#654',
    padding:'8px 2px',
    fontSize:14
  },
  waitCard:{
    margin:'30px auto',
    maxWidth:350,
    background:'#fffaf0',
    border:'1px solid #dbc39b',
    borderRadius:16,
    textAlign:'center',
    padding:'28px 20px'
  },
  bigPiece:{
    margin:'0 auto 12px',
    width:58,
    height:58,
    borderRadius:'50%',
    border:'3px solid #b3261e',
    color:'#b3261e',
    background:'#f6d89d',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontFamily:'serif',
    fontSize:32,
    fontWeight:900
  },
  waitTitle:{
    fontSize:24,
    fontWeight:900,
    color:'#54382b'
  },
  waitingText:{
    display:'block',
    marginTop:8,
    color:'#8c5a32'
  },
  loading:{
    margin:'15px 0 8px',
    color:'#b68b55'
  },
  waitTip:{
    fontSize:12,
    color:'#806d5e',
    lineHeight:1.6
  },
  cancel:{
    marginTop:20,
    border:'1px solid #b99b7a',
    background:'#fff',
    borderRadius:8,
    padding:'8px 18px'
  },
  gameWrap:{
    maxWidth:500,
    margin:'0 auto',
    paddingBottom:30
  },
  gameTop:{
    height:42,
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  live:{
    color:'#25864d',
    fontSize:11
  },
  match:{
    display:'grid',
    gridTemplateColumns:'1fr auto 1fr',
    alignItems:'center',
    gap:10,
    maxWidth:430,
    margin:'3px auto 7px',
    background:'#fff8e9',
    borderRadius:10,
    padding:'8px 12px'
  },
  status:{
    textAlign:'center',
    fontWeight:800,
    color:'#8c2f25',
    padding:'7px 5px',
    minHeight:20
  },
  spectatorStatus:{
    color:'#416b54'
  },
  board:{
    position:'relative',
    maxWidth:430,
    margin:'0 auto',
    aspectRatio:'8/9',
    backgroundColor:'#d8ad6b',
    backgroundImage:
      'linear-gradient(#6d4c2e 1px,transparent 1px),linear-gradient(90deg,#6d4c2e 1px,transparent 1px)',
    backgroundSize:'12.5% 11.111%',
    border:'3px solid #6d4c2e',
    boxSizing:'border-box'
  },
  cell:{
    position:'absolute',
    width:'12.5%',
    height:'11.111%',
    border:0,
    background:'transparent',
    padding:0,
    zIndex:3
  },
  dot:{
    width:34,
    height:34,
    borderRadius:'50%',
    display:'flex',
    alignItems:'center',
    justifyContent:'center'
  },
  piece:{
    fontStyle:'normal',
    width:32,
    height:32,
    borderRadius:'50%',
    background:'#f6d89d',
    border:'2px solid currentColor',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontFamily:'serif',
    fontWeight:900,
    fontSize:20,
    boxShadow:'0 2px 4px #0005'
  },
  can:{
    background:'#278c5577'
  },
  chosen:{
    boxShadow:'0 0 0 4px #ffd700cc'
  },
  river:{
    position:'absolute',
    left:0,
    right:0,
    top:'44.45%',
    height:'11.11%',
    background:'#d8ad6b',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontFamily:'serif',
    fontSize:20,
    color:'#6d4c2e',
    zIndex:1
  },
  actions:{
    display:'flex',
    gap:12,
    justifyContent:'center',
    margin:'13px auto'
  },
  drawOffer:{
    textAlign:'center',
    padding:8,
    background:'#fff0bd'
  },
  drawWaiting:{
    textAlign:'center',
    fontSize:12,
    padding:6,
    color:'#806000'
  },
  watchTip:{
    textAlign:'center',
    fontSize:12,
    color:'#60766a',
    marginTop:12
  },
  returnBtn:{
    display:'block',
    margin:'14px auto',
    padding:'9px 22px',
    border:0,
    borderRadius:9,
    background:'#8c5a32',
    color:'#fff'
  }
};
